var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 10 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3E4E5D",
  d: "M8.947 5h-.394V3.553a3.553 3.553 0 0 0-7.106 0V5h-.394C.47 5 0 5.471 0 6.053v5.526c0 .581.471 1.053 1.053 1.053h7.894c.582 0 1.053-.472 1.053-1.053V6.053C10 5.47 9.529 5 8.947 5M5 9.737a1.053 1.053 0 1 1 0-2.105 1.053 1.053 0 0 1 0 2.105m2.237-5A.263.263 0 0 1 6.974 5H3.026a.263.263 0 0 1-.263-.263V3.553a2.237 2.237 0 0 1 4.474 0z"
})));
export default SvgLock;